<div class="content layout-auto-1-auto">
  <div class="spawn">
    <p [hidden]="true" *ngIf="!receiptTable.isLoading">
      {{receiptTable.selectedRow?.rcptID}}
    </p>
  </div>
  <div class="content">
    <ng-container *ngIf="!receiptTable.isLoading && dataObject && dataObject.rcptID">
      <app-receipt-checkview #VCCheckview
                             [Data]="dataObject"
                             [inputTabinstance]="tabinstance">
      </app-receipt-checkview>
    </ng-container>
	  <ng-container *ngIf="receiptTable.isLoading">
		  <div class="splash loading">
			  <div class="spinner">
				  <div></div>
				  <div></div>
				  <div></div>
				  <div></div>
			  </div>
		  </div>
	  </ng-container>
  </div>
  <div class="md3-card-on-surface"
       style="margin-left: 8px; margin-bottom: 8px">
	  <exg-pager class="span-layout" *ngIf="receiptTable.state === 0"
	             (PageChange)="receiptTable.pageChanged($event)"
	             [pagingSource]="receiptTable.paging">
		  <ng-template #leftTemplate>
		  </ng-template>
		  <ng-template #rightTemplate>
			  <span *ngIf="receiptTable.isFiltered()">(gefiltert)</span>
		  </ng-template>
	  </exg-pager>
  </div>
</div>
